import { getPageType } from "@/getServerSideProps/params";
import { PageType } from "@/types/types";
import { useRouter } from "next/router";

export type RouteParams = {
  path: string | undefined;
  query: Record<string, string | string[] | undefined>;
  facetId: string[] | undefined;
  pageType: PageType;
  queryWithoutPageOrChunk: Record<string, string | string[] | undefined>;
};

export function useRouteParams(): RouteParams {
  const { query, asPath } = useRouter();

  const { type: type, facetId: facetId, ...queryParams } = query;

  const queryWithoutPageOrChunk = { ...queryParams };
  delete queryWithoutPageOrChunk.page;
  delete queryWithoutPageOrChunk.chunk;

  return {
    path: asPath?.split("?")[0]?.split("#")[0],
    query: queryParams,
    facetId: typeof facetId === "string" ? [facetId] : facetId,
    pageType: getPageType(query) || "browse",
    queryWithoutPageOrChunk,
  };
}
